export const APP_CODE = {
  CRM: 'CRM',
  CWO: 'CWO',
  TITANGUESTREG: 'TITANGUESTREG',
  TITANGUESTREGCLOUD: 'TITANGUESTREGCLOUD',
};
